import * as React from 'react';

import { ClickAwayListener } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((_theme) => ({
    custom: {
        '& .MuiButton-root': {
            margin: 0,
            padding: 0,
            height: '18px',
            width: '18px',
            marginTop: '-2px',
            '&:focus-visible': {
                backgroundColor: 'rgba(209, 224, 194, 0.2)',
                outline: 'none',
                border: '2px dashed #4F7E1D',
                borderRadius: '3px',
            },
        },
        '& .MuiButton-text': {
            padding: 0,
        },
    },
}));

const ToolTip = ({ title, tooltipText }) => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };

    const handleTooltipOpen = () => {
        setOpen(true);
    };
    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <div>
                <Tooltip
                    arrow
                    title={tooltipText}
                    placement={'top'}
                    enterTouchDelay={0}
                    onClose={handleTooltipClose}
                    open={open}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener>
                    <span style={{ lineHeight: '27px', width: '18px', marginLeft: '-6px' }} className={classes.custom}>
                        <Button disableFocusRipple onClick={handleTooltipOpen}>
                            {title}
                        </Button>
                    </span>
                </Tooltip>
            </div>
        </ClickAwayListener>
    );
};

export default ToolTip;
